/** @format */

export function hasPathNameChanged(pathName: string) {
    try {
        const { pathname, origin } = window.location;
        const newUrl = new URL(pathName, origin);

        return newUrl.pathname !== pathname;
    } catch (e) {
        return true;
    }
}
